export const dashboardConstants = {
    //bill card
    TOGGLE_PAPERLESS_BILLING_ENROLLMENT: 'TOGGLE_PAPERLESS_BILLING_ENROLLMENT',
    UPDATE_BILLING_INFO: 'UPDATE_BILLING_INFO',

    //outage card
    GET_DEFAULT_VIEW: 'GET_DEFAULT_VIEW',
    GET_OUTAGE_DETAIL_VIEW: 'GET_OUTAGE_DETAIL_VIEW'
}